import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import { parseCostEffect, type CostEffect } from "./util/cost"

export class RecurringInvestment {
  id: string | null = null
  accountNumber: string | null = null
  amount = 0
  estimatedInvestmentAmount = NaN
  buyingPowerImpact: number | null = null
  buyingPowerImpactEffect: CostEffect | null = null
  commission: number | null = null
  commissionEffect: CostEffect | null = null
  fees: number | null = null
  feesEffect: CostEffect | null = null
  clearingFees: number | null = null
  clearingFeesEffect: CostEffect | null = null
  regulatoryFees: number | null = null
  regulatoryFeesEffect: CostEffect | null = null
  createdAt: Date | null = null
  frequency: string | null = null
  fundingMethod: string | null = null
  nextInvestmentDate: Date | null = null
  nextTradeDate: Date | null = null
  symbol: string | null = null
  instrumentType: string | null = null
  status: string | null = null
  startDate: Date | null = null
  warnings: string[] = []
}

export const RECURRING_INVESTMENT_DESER: SchemaDeSer<RecurringInvestment> =
  new SchemaDeSerBuilder(RecurringInvestment)
    .ofStrings(
      "id",
      "accountNumber",
      "frequency",
      "fundingMethod",
      "symbol",
      "instrumentType",
      "status"
    )
    .ofFloat("amount")
    .ofFloat("estimatedInvestmentAmount")
    .ofFloat("buyingPowerImpact")
    .ofCustomEnum(
      "buyingPowerImpactEffect",
      "buying-power-impact-effect",
      parseCostEffect
    )
    .ofFloat("commission")
    .ofCustomEnum("commissionEffect", "commission-effect", parseCostEffect)
    .ofFloat("fees")
    .ofCustomEnum("feesEffect", "fees-effect", parseCostEffect)
    .ofFloat("clearingFees")
    .ofCustomEnum("clearingFeesEffect", "clearing-fees-effect", parseCostEffect)
    .ofFloat("regulatoryFees")
    .ofCustomEnum(
      "regulatoryFeesEffect",
      "regulatory-fees-effect",
      parseCostEffect
    )
    .ofDateTime("createdAt")
    .ofDate("nextInvestmentDate")
    .ofDate("startDate")
    .ofPrimitiveArray("warnings")
    .toDeSer()

export const RECURRING_INVESTMENT_REQUEST_DESER: SchemaDeSer<RecurringInvestment> =
  new SchemaDeSerBuilder(RecurringInvestment)
    .ofStrings(
      "id",
      "accountNumber",
      "frequency",
      "fundingMethod",
      "instrumentType",
      "symbol",
      "status"
    )
    .ofUnquotedFloat("amount")
    .ofDateTime("createdAt")
    .ofDate("nextTradeDate")
    .ofDate("startDate")
    .toDeSer()
